import React from "react";
import routeGuard from "src/Hooks/routeGuard";
import NewInstance from "src/components/ProjectInstance/new";
import { RESOURCE_TYPE, ROLES } from "src/constant/common";

const Instance = () => {
  return <NewInstance />;
};

export default routeGuard(Instance, RESOURCE_TYPE.PROJECT_INSTANCE, ROLES.ADMIN || ROLES.SERVICE_ADMIN);
